import { Injectable, signal } from '@angular/core';
import { tap } from 'rxjs';
import { WorkspaceFuncs } from '../workspace/workspace.func';
import { WorkspaceHolderService } from '../workspace/workspace.holder.service';
import { Board } from './board';
import { BoardService } from './board.service';

@Injectable({
  providedIn: 'root',
})
export class BoardHolderService {
  myPersonalBoard = signal<Board | undefined>(undefined);

  constructor(
    private boardService: BoardService,
    private workspaceHolderService: WorkspaceHolderService
  ) {}

  isCreator() {
    return WorkspaceFuncs.isCreator({
      workspace: this.workspaceHolderService.currentWorkspace(),
      board: this.myPersonalBoard()!,
    });
  }

  updateMyPersonalBoard$() {
    return this.boardService.updateBoard$(this.myPersonalBoard()!).pipe(
      tap((data) => {
        this.myPersonalBoard.set(data as Board);
      })
    );
  }
}
